import React from 'react';

import Video from '../../components/video';
import Metric from '../../components/metric';
import QuoteCarouselLegacy from '../../components/quote-carousel-legacy';
import ImageWithCaption from '../../components/image-with-caption';
import ImageWithFloatingText from '../../components/image-with-floating-text';
import MultiImageSection from '../../components/multi-image-section';
import InsightCTA from '../../components/insight-cta';
import Quote from "../../models/Quote/Quote";

/**
 * Rich-renderer function that can be consumed by React-Rich-Text render in order
 * to generate a styled element based on a particular rich text node, and it's
 * children
 *
 * @function
 * @param {object} node rich-text node
 */
const RichEntryPreview = node => {
  let content = null;
  const entryType = node?.data?.target?.sys?.contentType?.sys?.id;
  const entryTypeContent = node?.data?.target?.fields;

  if (entryType === 'video') {
    const { embedUrl, title } = entryTypeContent;
    
    content = <Video title={title} embedUrl={embedUrl} />;
  }

  if (entryType === 'metric') {
    const { title, percentage } = entryTypeContent;
    
    content = <Metric title={title} percentage={percentage} />;
  }

  //Note: quoteBlock only works when used in QuoteCarouselLegacy
  if (entryType === 'quoteBlock') {
    const embeddedQuotes = [];
    const { author, authorSubtitle, quote, client, image } = entryTypeContent;

    const singleQuote = {
      author: author,
      authorSubtitle: authorSubtitle,
      quote: quote,
      client: client,
      image: image
    };
    embeddedQuotes.push(new Quote(singleQuote));
    content = <QuoteCarouselLegacy quotes={embeddedQuotes} />;
  }

  if (entryType === 'imageWithCaption') {
    const { linkUrl, linkText, caption, captionAlignment } = entryTypeContent;
    const image = entryTypeContent?.image?.fields?.file?.url;
    const alt = entryTypeContent?.image?.fields?.title;
    const alignment = captionAlignment;
    
    content = <ImageWithCaption {...{ image, linkUrl, alt, caption, alignment, linkText }} />;
  }

  if (entryType === 'imageWithFloatingText') {
    const { imageAlignment, richBody } = node;
    const image = node?.image?.gatsbyImageData;
    const alt = node?.image?.title;
    const richText = richBody;

    content = <ImageWithFloatingText {...{image, alt, imageAlignment, richText}} />
  }

  if (entryType === 'multiImageSection') {
    content = <MultiImageSection isPreview images={entryTypeContent} />;
  }

  if (entryType === 'insightCta') {
    const { caption, buttonText, buttonUrl } = entryTypeContent;

    content = <InsightCTA {...{ caption, buttonText, buttonUrl }}/>
  }
  return content;
};

export default RichEntryPreview;
